import React from "react";
import { FilmSlate } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import MainCharacterBadges from "@/components/MainCharacterBadges";

export default function Layout({ children }) {
  return (
    <div className="h-screen w-full flex flex-col bg-slate-950 text-slate-50 overflow-hidden">
      <header
        data-testid="app-header"
        className="h-14 shrink-0 border-b border-slate-800 flex items-center justify-between px-4 bg-slate-950"
      >
        <Link to="/" className="flex items-center gap-2 group" data-testid="header-home-link">
          <FilmSlate size={22} weight="duotone" className="text-blue-500 group-hover:text-blue-400 transition-colors" />
          <span className="font-heading uppercase tracking-wider text-lg font-bold text-slate-50">
            TSV Video Generator
          </span>
        </Link>
        <div className="flex items-center gap-3">
          <MainCharacterBadges />
          <span className="font-mono text-[10px] uppercase tracking-widest text-slate-600 border border-slate-800 px-2 py-1 rounded-sm">
            Phase 1 · Intake &amp; Character Lock
          </span>
        </div>
      </header>
      <main className="flex-1 overflow-y-auto">{children}</main>
    </div>
  );
}
